/*
  Ivy Pillow — inklapbare rijen op de productpagina: klikbare kop met
  plusje, het paneel klapt smooth open via de grid-rows-techniek (CSS).
*/
(() => {
  function init(scope) {
    const bereik = scope && scope.querySelectorAll ? scope : document;
    bereik.querySelectorAll('[data-ivy-accordeon]').forEach((accordeon) => {
      if (accordeon.dataset.ivyInit === 'true') return;
      accordeon.dataset.ivyInit = 'true';

      const knop = accordeon.querySelector('.ivy-accordeon__kop');
      if (!knop) return;

      knop.addEventListener('click', () => {
        const open = accordeon.classList.toggle('ivy-accordeon--open');
        knop.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => init(document));
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => init(e.target));
  }
})();
